import { IErrorCodes } from "./types";

export const DEFAULT_CURRENCY = " грн.";
export const DEFAULT_ADD_COST_VALUE = 5;
export const TAXI_COLUMN_ID = 0;
export const ACCENT_COLOR_MAIN = "#fdd000";
export const ACCENT_COLOR_HOVER = "#ffe172";
export const DEFAULT_RADIUS = 5;
export const MAX_RADIUS = 80;
export const DEFAULT_CENTER = { lat: 50.4501, lng: 30.5234 };
export const DEFAULT_ZOOM = 12;
export const DEFAULT_TARIFF_VALUE = "Базовый";

export const ERROR_CODES: IErrorCodes[] = [
  { id: 0, message: "Невідома помилка" },
  {
    id: -2,
    message:
      "Помилка авторизації користувача. Невірно вказано логін або пароль",
  },
  {
    id: -3,
    message:
      "Не вдалося знайти користувача за запитаним логіном або номером телефону",
  },
  {
    id: -4,
    message:
      "Не вдалося знайти користувача за його номером телефону, оскільки таких користувачів кілька",
  },
  { id: -5, message: "Занадто багато запитів за короткий час" },
  { id: -10, message: "Неправильні параметри запиту" },
  {
    id: -11,
    message:
      "Помилка виконання замовлення, оскільки користувача заблоковано диспетчерською",
  },
  {
    id: -12,
    message:
      "Помилка виконання замовлення, оскільки недостатньо грошей на балансі для виконання замовлення",
  },
  {
    id: -13,
    message:
      "Помилка створення замовлення, оскільки зазначеної адреси (вулиці) немає в базі даних",
  },
  {
    id: -14,
    message:
      "Помилка створення замовлення, оскільки зазначеної адреси (об'єкта) немає в базі даних",
  },
  { id: -15, message: "Неправильний номер колони" },
  {
    id: -16,
    message:
      "Використання терміналу заборонено налаштуваннями в диспетчерській",
  },
  { id: -20, message: "Дублювання запиту. Подібний запит уже обробляється" },
  {
    id: -21,
    message:
      "Дублювання замовлення. Ви не можете створювати подібне замовлення, поки не знайшлася машина на попереднє замовлення",
  },
  {
    id: -22,
    message:
      "Помилка перетворення ід локальних координат у географічні (довгота, широта), або навпаки",
  },
  { id: -23, message: "Номер телефону в чорному списку" },
  { id: -24, message: "Оплата готівкою заборонена" },
  { id: -25, message: "Безготівковий розрахунок заборонено" },
  { id: -30, message: "Невідома помилка реєстрації" },
  { id: -31, message: 'Операція заборонена налаштуваннями "Таксі Навігатор"' },
  {
    id: -32,
    message: "Користувач із таким номером телефону вже зареєстрований",
  },
  { id: -34, message: "Невірний формат номера телефону" },
  { id: -35, message: "Невірний код підтвердження" },
  { id: -36, message: "Не вказано пароль" },
  { id: -37, message: "Пароль підтвердження не відповідає паролю" },
  {
    id: -38,
    message: "Довжина пароля не задовольняє умові від 7 до 30 символів",
  },
  { id: -40, message: "Операцію заборонено. Потрібно підтвердження телефону" },
  {
    id: -42,
    message: "Помилка верифікації телефону. Телефон уже підтверджено",
  },
  {
    id: -50,
    message:
      'Використання бонусів заборонено налаштуваннями "Таксі Навігатор" або користувач неавторизований',
  },
  {
    id: -51,
    message: "У користувача недостатньо бонусів для оплати замовлення",
  },
  { id: -52, message: "Бонусів для оплати менше, ніж вартість замовлення" },
  { id: -53, message: 'Оплата бонусами неможлива для замовлення "по місту"' },
  { id: -54, message: "Дата і час подачі машини має бути пізніше" },
  {
    id: -55,
    message: "Додаткова сума має бути більшою за -100000 і меншою за 100000",
  },
  { id: -64, message: "Неіснуюча користувацька додаткова послуга" },
  { id: -84, message: "Перевищено кількість обраних адрес клієнта" },
  { id: -100, message: "Ошибка выполнения операции" },
];

export const findErrorById = (id: number) => {
  const error = ERROR_CODES.find((error) => error.id === id);
  return error ? error.message : "Невідома помилка";
};
